var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4571 9.66375L23.834 17.767C18.8506 19.6304 14.7773 25.5237 14.7773 30.8537V63.0502C14.7773 68.1635 18.1574 74.8802 22.2741 77.9568L40.9073 91.8673C47.0175 96.4606 57.0704 96.4606 63.1804 91.8673L81.8142 77.9568C85.9308 74.8802 89.3104 68.1635 89.3104 63.0502V30.8537C89.3104 25.5237 85.2371 19.6304 80.2537 17.767L58.6308 9.66375C54.9475 8.32042 49.0537 8.32042 45.4571 9.66375Z",
    stroke: "#E0BA56",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.9985 47.3197C51.8251 47.3197 51.6085 47.3197 51.4352 47.3197C47.3618 47.1897 44.1118 43.8097 44.1118 39.6931C44.1118 35.4898 47.5352 32.0664 51.7385 32.0664C55.9418 32.0664 59.3652 35.4898 59.3652 39.6931C59.3218 43.8531 56.0718 47.1897 51.9985 47.3197Z",
    stroke: "#E0BA56",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.3726 59.4531C39.2124 62.2264 39.2124 66.7764 43.3726 69.5493C48.0959 72.7131 55.8526 72.7131 60.5759 69.5493C64.7359 66.7764 64.7359 62.2264 60.5759 59.4531C55.8959 56.2897 48.1392 56.2897 43.3726 59.4531Z",
    stroke: "#E0BA56",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.effde70019b9c8a155075bbcfb5d228c.svg";
export { ForwardRef as ReactComponent };